module.exports = require('./lib/visibility.timers.js')



//////////////////
// WEBPACK FOOTER
// ../~/visibilityjs/index.js
// module id = 465
// module chunks = 1